import { Fragment } from "react";
import LandscapeSection from "src/components/shared/EntriesGenerator/Section/LandscapeSection/LandscapeSection";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";

interface EntrySectionsRendererProps {
  sections: any[];
  id: string;
  shouldHideElement: (section: any) => boolean;
  entryIndex?: number;
  headerOffset?: number;
}

const EntrySectionsRenderer = ({
  sections,
  id,
  shouldHideElement,
  entryIndex,
  headerOffset: offset,
}: EntrySectionsRendererProps) => {
  if (!Array.isArray(sections) || sections.length === 0) return null;
  return (
    <Fragment>
      {sections.map((s, i) => {
        if (shouldHideElement(s)) return null;
        return s.subSections ? (
          <Fragment key={`fr-${i}-${id}`}>
            {s.subSections.map((sub: any, subI: number) => {
              if (shouldHideElement(sub)) return null;
              return <LandscapeSection section={sub} key={`sub-${subI}`} />;
            })}
          </Fragment>
        ) : (
          <Section
            entryIndex={entryIndex}
            key={i}
            sIndex={i}
            section={s}
            offset={offset}
            stickyHeaders={false}
          />
        );
      })}
    </Fragment>
  );
};

export default EntrySectionsRenderer;
